module.exports = __webpack_public_path__ + "house-ico.webp?706bd4c86f89804f23eeab37044b0a2f";